/**
 * LOCAL TESTING VERSION of send-newsletter API
 * 
 * This is a simplified version for local testing without email sending.
 * The real version is in /api/send-newsletter.ts and runs on Vercel.
 * 
 * To use this locally:
 * 1. Import this function in your component
 * 2. Call it directly instead of fetching /api/send-newsletter
 */

import { getArticles, getNewsletterSubscribers } from '../lib/supabase';

export const localSendNewsletter = async () => {
  try {
    // Get latest published articles
    const articles = await getArticles(false);
    const latestArticles = articles.slice(0, 3);

    // Get active subscribers
    const subscribers = await getNewsletterSubscribers();
    // @ts-ignore - Type inference issue
    const activeSubscribers = subscribers.filter(sub => sub.is_active);

    if (latestArticles.length === 0) {
      return {
        success: false,
        message: 'No published articles found to send in newsletter',
      };
    }

    if (activeSubscribers.length === 0) {
      return {
        success: false,
        message: 'No active subscribers found',
      };
    }

    // In local mode, we just simulate sending
    console.log('📧 LOCAL NEWSLETTER SIMULATION');
    console.log('===============================');
    console.log(`Would send to ${activeSubscribers.length} subscribers`);
    console.log('\nArticles to include:');
    latestArticles.forEach((article, index) => {
      // @ts-ignore - Type inference issue
      console.log(`${index + 1}. ${article.title}`);
    });
    console.log('\nSubscribers:');
    activeSubscribers.slice(0, 5).forEach((sub, index) => {
      // @ts-ignore - Type inference issue
      console.log(`${index + 1}. ${sub.email}`);
    });
    if (activeSubscribers.length > 5) {
      console.log(`... and ${activeSubscribers.length - 5} more`);
    }
    console.log('===============================');

    return {
      success: true,
      message: `Newsletter simulation complete. Would send to ${activeSubscribers.length} subscribers with ${latestArticles.length} articles. Check console for details.`,
      data: {
        subscribers_count: activeSubscribers.length,
        articles_count: latestArticles.length,
        articles: latestArticles.map(a => ({
          // @ts-ignore - Type inference issue
          title: a.title,
          // @ts-ignore - Type inference issue
          slug: a.slug,
        })),
      },
    };
  } catch (error: any) {
    console.error('Error simulating newsletter:', error);
    return {
      success: false,
      message: error.message || 'Failed to simulate newsletter',
    };
  }
};